import I18n from 'i18n-js'
import brTranslations from './pt-BR'

I18n.defaultLocale = 'pt-BR'
I18n.locale = 'pt-BR'

I18n.translations['pt-BR'] = brTranslations

export default I18n
